import { blogProduct } from '@/types'
import { SectionWrap, Content, StoriesSwiper, StoryImage, Tile, TitleWrapper } from './ExozStories.styles'
import { useRouter } from 'next/router'
import Container from './Container'
import { Spacing, Heading } from '@big-red-group/storefront-common-ui'
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/css'
import { LazyLoadComponent } from 'react-lazy-load-image-component'
import { useTileClick } from '@/hooks/HTMLElementClickHook'

const ExozStories: React.FC<{ stories: blogProduct[] }> = ({ stories }) => {
  const router = useRouter()
  const { lang } = router.query
  const trackTileClicked = useTileClick('Editorial')

  if (!stories || !stories.length) return null

  const slicedStories = stories.slice(0, 3)

  const renderSwiper = () => {
    return (
      <Swiper
        pagination={{ clickable: true }}
        breakpoints={{
          0: {
            spaceBetween: 16,
            slidesPerView: 'auto',
            enabled: true,
          },
          500: {
            spaceBetween: 24,
            slidesPerView: 'auto',
            enabled: true,
          },
          1100: {
            spaceBetween: 70,
            slidesPerView: 3,
            enabled: false,
          },
        }}
      >
        {slicedStories.map(({ image, title, link }, index) => (
          <SwiperSlide className="story-swiper-tile" key={link}>
            <Tile
              href={`${lang}/${link}`}
              key={link}
              data-testid={`story-${link}`}
              onClick={(event) => {
                trackTileClicked({
                  tileTitle: title,
                  url: `/${lang}/${link}`,
                  position: index + 1,
                  sectionTitle: 'Need inspo for your next trip?',
                  imageUrl: image,
                  event,
                })
              }}
            >
              <LazyLoadComponent>
                <StoryImage image={image} />
              </LazyLoadComponent>
              <Heading size="XS" bold={false} spacing={false}>
                {title}
              </Heading>
            </Tile>
          </SwiperSlide>
        ))}
      </Swiper>
    )
  }

  return (
    <SectionWrap data-mcp-id="exoz-stories">
      <Content>
        <Container dataTestId="exoz-stories">
          <TitleWrapper>
            <Heading size="XL">
              Need inspo for your next trip?
              <svg width="76" height="7" viewBox="0 0 76 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M73.454 2.30116C61.1265 1.57649 45.0336 3.19057 32.6483 3.8218C23.5155 4.28726 14.3736 4.91887 5.35518 6.08611C5.13644 6.11442 4.88476 6.15362 4.61125 6.19621C3.82294 6.31899 2.8533 6.47 1.96844 6.47C1.15744 6.47 0.5 5.86519 0.5 5.11913C0.5 4.37306 1.15744 3.76826 1.96844 3.76826C2.59198 3.76826 3.17006 3.6778 3.85917 3.56998C4.19008 3.5182 4.54658 3.46242 4.94601 3.41072C14.0845 2.22794 23.321 1.59129 32.4859 1.12419C44.9227 0.490338 57.3793 0.198631 69.8738 0.933123C70.5567 0.973266 71.5662 1.0513 72.3934 1.11821C72.8095 1.15187 73.1837 1.18306 73.454 1.20584L73.8912 1.24304C74.6986 1.31283 75.2922 1.9716 75.2164 2.71439C75.1405 3.45719 75.5247 2.65766 74.7173 2.58788L74.9011 2.62089C74.6334 2.59833 75.8242 2.33446 75.4126 2.30116C74.5844 2.23417 74.0978 2.33901 73.454 2.30116Z"
                  fill="#FCC703"
                />
              </svg>
            </Heading>
          </TitleWrapper>
          <StoriesSwiper>{renderSwiper()}</StoriesSwiper>
          <Spacing size="L" />
        </Container>
      </Content>
    </SectionWrap>
  )
}

export default ExozStories
